/**
 * Device Files Search Schema
 * @description デバイスファイル画面の検索パラメータスキーマ
 */

import { OrderDirection } from "@/constants/orderDirection";
import { z } from "zod";
import { DEVICE_FILE_PAGE_SIZE } from "./-constants";
import { DeviceFileSortColumn } from "./-query/type";

const DEVICE_FOLDER_TYPES = [
  "INSTALLATION",
  "RETRIEVAL",
  "ASSIGNMENT",
  "RETURN",
  "RECEIVING",
  "INITIAL_SETUP",
  "INVENTORY",
  "REPAIR",
  "REPLACEMENT",
  "DISPOSAL",
  "DOCUMENT",
] as const;

export const DeviceFilesSearchSchema = z.object({
  folderType: z.enum(DEVICE_FOLDER_TYPES).optional().catch(undefined),
  pageIndex: z.number().int().min(0).default(0),
  pageSize: z.number().int().min(1).max(2000).default(DEVICE_FILE_PAGE_SIZE),
  sortColumn: z.nativeEnum(DeviceFileSortColumn).optional().catch(undefined),
  sortOrder: z.nativeEnum(OrderDirection).optional().catch(undefined),
});

export type DeviceFilesSearch = z.infer<typeof DeviceFilesSearchSchema>;
